





import Vue from 'vue';
import { editMutations } from '@/modules/servis/ozakazka/store/types';
import { ServicePackage } from '@/modules/servis/zakazka/ServicePackage';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { START_LOADING, END_LOADING } from '@/main/store/listEditTypes';

import { apiProvider } from '../../api';
import { store } from '../../store/edit';

export default Vue.extend({
	name: 'MicroPackageSelect',
	components: {
		PackageSelect: ServicePackage.components.Select,
	},
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				mutationName: `${this.storeUri}/${editMutations.SERVICE_PACKAGE}`,
			};
		},
		vozidloFilter(): object {
			return {
				VozidloId: this.VozidloId,
			};
		},
	},
	methods: {
		async clear() {
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			await apiProvider.deletePackage(this.OzakazkaId!);
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
		},
	},

});
